const ecommerce_scrollto = ( selector ) =>
{
  const header_height = cached_elements.get_node( '#js-header' ).scrollHeight;
  const el_top = cached_elements.get_node( selector ).getBoundingClientRect().top;

  window.scrollTo(
  {
    top: ( el_top - header_height - 50 ),
    left: 0,
    behavior: 'smooth'
  } )
};